import "../_namespaces.js";
import "./base.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Models ??= {};

AssessmentViewer.Models.CompletionPage = class CompletionPage extends AssessmentViewer.Models.Base {
  constructor() {
    super(...arguments);
    this.scoreWithinRange = this.scoreWithinRange.bind(this);
    this.redirects = this.redirects.bind(this);
  }

  scoreWithinRange(score) {
    let min = parseFloat(this.get("minScore"));
    let max = parseFloat(this.get("maxScore"));

    if (isNaN(min)) {
      min = null;
    }
    if (isNaN(max)) {
      max = null;
    }

    if (min != null && max != null) {
      return min <= score && score <= max;
    } else if (min != null) {
      return min <= score;
    } else if (max != null) {
      return score <= max;
    } else {
      return true;
    }
  }

  // Returns true if this completion page has a page that should be redirected to
  redirects() {
    return this.get("type") === "redirect";
  }
};
